export default __webpack_public_path__ + "static/media/hz-me.d18f4fb0.png";